import * as React from "react";
import { EmrHeart, EmrLiquid } from "@medstonetech/slate-icons";
import { MedicalStar, RFilled, Restricted } from "icons";
import { DietType } from "enums";
import { Icon } from "@chakra-ui/react";

type DietTypeIconProps = React.ComponentProps<typeof Icon>;

const DIET_TYPE_ICON: Record<
  DietType,
  (props?: DietTypeIconProps) => JSX.Element
> = {
  Regular: (props) => <Icon as={RFilled} color="cyan" {...props} />,
  Clear_liquid: (props) => <Icon as={EmrLiquid} color="orange" {...props} />,
  NPO: (props) => <Icon as={Restricted} color="orange" {...props} />,
  Healthy: (props) => <Icon as={EmrHeart} color="cyan" {...props} />,
  Diabetic: (props) => <Icon as={MedicalStar} color="orange" {...props} />,
};

export { DIET_TYPE_ICON };
